import { setRedactorEditor } from "packs/redactor_main";

// Only initialize Redactor if textarea exists and hasn't been initialized
// This prevents double initialization when imported by other packs
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.redactor-textarea') && !document.querySelector('.redactor-box')) {
    setRedactorEditor();
  }
});

let isFormDirty = false;
let isFormSubmitting = false;

function handleFormSubmission(){
  let loader = document.getElementById('submitformloader');
  let submitButton = document.getElementById('topic_submission') || document.getElementById('contact_btn');
  submitButton.disabled = true; 
  submitButton.classList.add('opacity-50', 'cursor-not-allowed'); 
  submitButton.value = '';
  loader.classList.remove('hidden');

  // Set a timeout to hide the loader if the page doesn't reload within 10 seconds
  let timeout = setTimeout(() => {
    loader.classList.add('hidden'); 
    submitButton.disabled = false; 
    submitButton.value = `${I18n.t('apply')}`; 
    submitButton.classList.remove('opacity-50', 'cursor-not-allowed'); 
  }, 5000); 

  // Optionally clear the timeout if the page reloads (not necessary if page is reloaded normally)
  window.addEventListener('beforeunload', function() {
    clearTimeout(timeout); 
  });
}

  let targetForms = document.querySelectorAll('#new_topic, .edit_topic , #contact_us');

  // Attach submit event to target forms
  targetForms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      isFormSubmitting = true;
      handleFormSubmission();
    });

    // Track input changes to determine if the form is dirty
    form.addEventListener('input', () => {
      isFormDirty = true;
    });
  });

window.addEventListener('beforeunload', function (event) {
  let submitButton = document.getElementById('topic_submission') || document.getElementById('contact_btn');

  if (isFormDirty && !isFormSubmitting && submitButton ) {
    event.preventDefault();
    event.returnValue = '';
  }
});